import { render, staticRenderFns } from "./InvoiceValue.vue?vue&type=template&id=67489256&"
import script from "./InvoiceValue.vue?vue&type=script&lang=js&"
export * from "./InvoiceValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports